import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SeoMeta from "@/components/feature/SeoMeta";
import { categories } from "@/mocks/videos";

export default function AboutPage() {
  return (
    <div className="bg-background-50 min-h-screen">
      <SeoMeta
        title="关于我们 - 国产吃瓜视频"
        description="国产吃瓜视频是一个专注娱乐热点与圈内资讯的视频聚合平台，聚合全网热门吃瓜视频合集、精选与大全内容，按事件热度实时整理，做你日常吃瓜的首选站点。"
        type="profile"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于国产吃瓜视频",
          url: "https://www.readdy.ai/about",
          mainEntity: {
            "@type": "Organization",
            name: "国产吃瓜视频",
            description: "聚合全网热门吃瓜视频合集、精选与大全内容的娱乐视频聚合平台",
            email: "contact@guavideo.example",
          },
        }}
      />
      <SiteHeader />

      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20warm%20stage%20lights%20and%20bokeh%20glow%20backdrop%20in%20coral%20red%20and%20golden%20orange%20tones%2C%20abstract%20entertainment%20industry%20atmosphere%2C%20cinematic%20dreamy%20composition%2C%20no%20text&width=1800&height=700&seq=gua-about-01&orientation=landscape"
            alt="关于国产吃瓜视频"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-32 pb-20 md:pt-40 md:pb-24 w-full">
          <nav className="flex items-center gap-1 text-sm text-background-50/80 mb-5 flex-wrap">
            <Link to="/" className="hover:text-background-50">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-50">关于我们</span>
          </nav>
          <h1 className="font-heading text-3xl md:text-5xl font-black text-background-50">关于国产吃瓜视频</h1>
          <p className="mt-4 max-w-2xl text-background-50/85">
            聚合全网热门吃瓜视频合集与精选内容，做你日常吃瓜的首选站点。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-4">
              我们<span className="text-primary-600">是谁</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              国产吃瓜视频是一个专注娱乐热点与圈内资讯的视频聚合平台。我们把分散在全网各处的热门吃瓜视频合集、精选与大全内容汇聚到一起，按事件热度实时整理，让想看吃瓜视频的你不用再到处翻找。
            </p>
            <p className="text-foreground-600 leading-relaxed">
              无论是明星八卦、综艺名场面、热搜事件盘点，还是红毯现场、音乐舞台与圈内幕后，我们都用心筛选、精心编排，希望用高质量的内容陪你度过每一个想吃瓜的时刻。
            </p>
          </div>
          <div className="relative rounded-2xl overflow-hidden min-h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=stylized%20entertainment%20backstage%20with%20soft%20warm%20golden%20lighting%20and%20spotlight%20on%20stage%2C%20abstract%20media%20team%20working%20atmosphere%2C%20cinematic%20warm%20tones%2C%20no%20text%20no%20faces&width=1000&height=700&seq=gua-about-02&orientation=portrait"
              alt="内容团队工作场景"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* 理念与原则 */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              发展理念与<span className="text-primary-600">内容原则</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">我们坚持做好这几件事</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: "ri-timer-flash-line", t: "实时追踪", d: "全天候跟踪热点，重大事件优先加急上线，不让你错过任何新瓜。" },
              { icon: "ri-layout-masonry-line", t: "精选编排", d: "从海量内容中筛选高质量片段，按分类与热度精心编排。" },
              { icon: "ri-quill-pen-line", t: "理性客观", d: "坚持客观梳理事件脉络，不渲染、不夸大，理性吃瓜有依据。" },
              { icon: "ri-community-line", t: "免费开放", d: "全部内容免费观看，无需注册，让每个人都能轻松吃瓜。" },
            ].map((item) => (
              <div key={item.t} className="bg-background-50 border border-background-200 rounded-2xl p-6">
                <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-bold text-foreground-950">{item.t}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 分类一览 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">内容覆盖分类</h2>
            <p className="mt-2 text-sm text-foreground-600">想看的方向，这里都有</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              className="group flex items-center gap-4 bg-background-50 border border-background-200 rounded-xl p-4 hover:border-primary-300 hover:bg-primary-50/40 transition-colors"
            >
              <img src={c.cover} alt={c.name} className="w-20 h-20 object-cover rounded-lg" />
              <div>
                <h3 className="font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">{c.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">{c.count} 个视频</p>
              </div>
              <i className="ri-arrow-right-line ml-auto text-primary-500"></i>
            </Link>
          ))}
        </div>
      </section>

      {/* 口碑 */}
      <section className="bg-primary-950 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <h2 className="text-center font-heading text-2xl md:text-3xl font-black text-background-50 mb-10">
            网友<span className="text-accent-400">口碑</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              { name: "小王爱看剧", text: "分类特别清楚，想看哪类直接点，省得我到处翻找，更新也很快。" },
              { name: "吃瓜爱好者", text: "排行榜很真实，热度高的确实都是大家都在看的，推荐得很准。" },
              { name: "追综达人", text: "综艺名场面合集太懂我了，高能片段都收录了，每天必刷。" },
            ].map((t) => (
              <div key={t.name} className="bg-background-50/10 border border-background-50/20 rounded-2xl p-6">
                <div className="flex items-center gap-1 text-accent-400 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <p className="text-background-50/90 text-sm leading-relaxed">{t.text}</p>
                <p className="mt-4 text-sm text-background-50/70 font-semibold">{t.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 联系 */}
      <section className="mx-auto max-w-4xl px-4 md:px-6 py-14 md:py-20 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">联系我们</h2>
        <p className="mt-3 text-foreground-600">
          有合作意向或优质内容投稿？欢迎通过以下方式与我们联系，我们会在工作时间尽快回复。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="mailto:contact@guavideo.example"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-bold whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-mail-line"></i> contact@guavideo.example
          </a>
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 font-bold whitespace-nowrap hover:bg-background-200 transition-colors"
          >
            <i className="ri-question-line"></i> 常见问题
          </Link>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}